import { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Logo from '../assets/images/Logo_HIRSCH.png';

// Importiere die Icons
import { faCheck, faEnvelope, faWarning, faX } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BAUMISCH_IMAGE from '../assets/images/Abfallarten/Baumisch-Abf\u00e4lle.jpg';
import BAUSCHUTT_IMAGE from '../assets/images/Abfallarten/Bauschutt.jpg';
import BODEN_STEINE_IMAGE from '../assets/images/Abfallarten/Boden - Steine -Abf\u00e4llen..jpg';
import GRUENSCHNITT_IMAGE from '../assets/images/Abfallarten/Gartenabf\u00e4llen.jpg';
import HOLZ_IMAGE from '../assets/images/Abfallarten/Holz-Abf\u00e4llen.jpg';
import METALL_IMAGE from '../assets/images/Abfallarten/Metall-Schrott.jpg';
import PAPIER_PAPPE_IMAGE from '../assets/images/Abfallarten/Papier-Pappe.jpg';
import BAUMISCH from '../assets/images/icons/Baumisch.png';
import BAUSCHUTT from '../assets/images/icons/Bauschutt.png';
import BODENUNDSTEINE from '../assets/images/icons/Boden und Stein.png';
import { default as GEMISCHTEABFAELLE, default as SONSTIGEABFAELLE } from '../assets/images/icons/Gemischte Abfaelle.png';
import GRUENSCHNITT from '../assets/images/icons/Gruenschnitt.png';
import HOLZ from '../assets/images/icons/Holz.png';
import METALL from '../assets/images/icons/Metall.png';
import PAPIERUNDPAPPE from '../assets/images/icons/Papier und Pappe.png';
import SPERRMUELL from '../assets/images/icons/Sperrmuell.png';

// Strukturierte Abfallart-Daten
const wasteTypeData = {
    'baumisch-abfall': {
        title: 'BAUMISCH-ABFALL',
        icon: BAUMISCH,
        detailImage: BAUMISCH_IMAGE,
        slug: 'baumisch-abfall',
        shortDescription: 'Gemischte Abfälle aus Bau- und Renovierungsarbeiten',
        description: 'In einen Baumischabfall Container dürfen Abfälle die bei Bauarbeiten wie Neubau, Sanierung oder Abbruch anfallen. Auch Haushaltsauflösungen und hausmüllähnliche Abfälle aus privaten Haushalten, Unternehmen und öffentlichen Einrichtungen, bei denen keine weitere Stofftrennung möglich ist.',
        allowed: [
            'Altkleider, Teppichreste, Textilien',
            'Altmöbel',
            'Baumischabfall',
            'Eimer, Folien, Kunststoffe, Plastik',
            'Gummi',
            'Holz, Paletten, Sägespäne',
            'Kabel, Kabelreste',
            'Papier, Pappe',
            'Putz, Tapetenreste',
            'Strohmatten',
            'Verpackungen, Verpackungsstyropor',
            'Gemischte Bauabfälle',
            'Bettgestelle, Couches, Regale, Schränke, Sofas, Stühle, Tische',
            'Sperrige Holz Gegenstände',
            'Pappe',
            'Dosen, Metalleimer, leichte Metalle',
            'Einwegpaletten, Gemische aus Holz, Holzkisten, Spanplatten',
            'Folien, Kunststoffe, Kunststoffrohre, Plastik, Tüten',
            'Papier, Zellstoffabfälle',
            'Textilien',
            'Verbundverpackungen'
        ],
        notAllowed: [
            'Carbon, Carbonfaserverstärkte Kunststoffe, Glasfaserverstärkte Kunststoffe',
            'Gartenabfälle & Bodenaushub',
            'Unverpackte Lebensmittelreste und Schlachtabfälle',
            'Leuchtstoff- & Neonröhren',
            'Brandabfälle',
            'Reifen',
            'Dachpappe',
            'Dämmmaterial, Dämmplatten, Styropor',
            'Elektroschrott',
            'Farben und Lacke, Spraydosen',
            'Gasflaschen',
            'Autoteile, Windkraftanlagen, Airbags'
        ],
        dangerous: [
            'A4 Holz, behandeltes Holz aus dem Außenbereich',
            'Asbest',
            'KMF, Glaswolle & Minerallwolle'
        ]
    },
    'bauschutt': {
        title: 'BAUSCHUTT',
        icon: BAUSCHUTT,
        detailImage: BAUSCHUTT_IMAGE,
        slug: 'bauschutt',
        shortDescription: 'Mineralische Abfälle aus Abbruch- und Renovierungsarbeiten',
        description: 'Mineralische Abfälle wie Beton, Ziegel, Fliesen und Mörtel sind ideal für Abriss- und Renovierungsarbeiten.',
        allowed: [
            'Dachziegel, Ziegelsteine',
            'Fliesen, Kacheln, Mörtelreste, Putzreste',
            'Reiner Betonabbruch',
            'Mauerwerk',
            'Pissoirs, Toiletten, Waschbecken',
            'Estrich'
        ],
        notAllowed: [
            'Kamin, Schornstein, rußverschmutzte Mineralik',
            'Erde, Bodenaushub',
            'Folien',
            'Gasbeton, Gips, Gipskartonplatten, Porenbeton, Styroporplatten',
            'Glas oder Glasreste',
            'Fenster',
            'Holzreste, Holzsplitter, Sägespäne',
            'Kabel',
            'Metalle, Moniereisen',
            'Mineralwolle',
            'Strohmatten',
            'Teeranhaftungen',
            'Flüssige Abfälle',
            'Farben, Lacke'
        ],
        dangerous: [
            'A4 Holz, behandelt Holz aus dem Außenbereich',
            'Asbest',
            'KMF, Glaswolle & Minerallwolle'
        ]
    },
    'gruenschnitt': {
        title: 'GRÜNSCHNITT',
        icon: GRUENSCHNITT,
        detailImage: GRUENSCHNITT_IMAGE,
        slug: 'gruenschnitt',
        shortDescription: 'Gartenabfälle wie Äste, Zweige, Laub und Rasenschnitt',
        description: 'Baum- und Strauchschnitt ist perfekt für die Gartenarbeit und umfasst alle natürlichen Gartenabfälle.',
        allowed: [
            'Astwerk',
            'Blumen, Blätter, Gräser, Grünschnitt',
            'Heckenschnitt, Laub, Mulch, Rasenschnitt',
            'Stauden, Strauchwerk, Unkraut',
            'Zweige',
            'Baumstubben, Baumstämme, Baumstümpfe',
            'Baumwurzeln, Große Wurzeln, Wurzelstock',
            'Stubben',
            'Wurzelwerk'
        ],
        notAllowed: [
            'Bauschutt',
            'Boden, Erde',
            'Kunststoffe, Plastik',
            'Metalle',
            'Steine',
            'Küchenabfälle'
        ]
    },
    'holz': {
        title: 'HOLZ',
        icon: HOLZ,
        detailImage: HOLZ_IMAGE,
        slug: 'holz',
        shortDescription: 'Unbehandeltes und behandeltes Holz aus dem Innenbereich',
        description: 'Naturbelassenes und unbehandeltes Holz, gestrichenes oder lackiertes Holz aus dem Innenbereich ohne Holzschutzmittel.',
        allowed: [
            'Altholz',
            'Dielen, Innentüren, Leimholzplatten',
            'Parkett, Profilbretter, Zierbalken',
            'Behandeltes Holz, beschichtetes Holz',
            'Lackiertes Holz, unbehandeltes Holz',
            'Verleimtes Holz aus dem Innenbereich'
        ],
        notAllowed: [
            'Bahnschwellen',
            'Behandeltes Holz aus dem Außenbereich',
            'Balkongeländer',
            'Gartenmöbel aus Holz',
            'Gartenzäune, Holzterrassen, Holzzäune, Jägerzäune',
            'Pflanzpfähle',
            'Holzschutzmittelbelastetes Holz, stark lackiertes Holz',
            'Baumstubben, Baumstämme, Wurzeln',
            'Glas'
        ]
    },
    'sonstige-abfaelle': {
        title: 'SONSTIGE ABFÄLLE',
        icon: SONSTIGEABFAELLE,
        detailImage: '',
        slug: 'sonstige-abfaelle',
        shortDescription: 'Verschiedene nicht sortierte Abfälle, die keiner speziellen Kategorie zugeordnet werden können',
        description: 'Für Sonstige Abfälle sind aktuell keine Container online buchbar.\nBitte melden Sie sich unter container@hirsch-gmbh.com oder 0421 - 25802 - 0.',
        allowed: [],
        notAllowed: []
    },
    'metall': {
        title: 'METALL',
        icon: METALL,
        detailImage: METALL_IMAGE,
        slug: 'metall',
        shortDescription: 'Altmetalle wie Eisen, Stahl, Aluminium und andere Metallabfälle',
        description: 'Alle wiederverwertbaren Metalle können gemischt in einem Container entsorgt werden. Wertstoff mit hoher Recyclingquote.',
        allowed: [
            'Alu, Blech, Eisen',
            'Kupfer, Messing, Stahl',
            'Alle nicht elektrobetriebenen Metallgegenstände'
        ],
        notAllowed: [
            'Bandschutztüren',
            'Heizkörper',
            'Elektroschrott',
            'Küchengeräte',
            'Drucker',
            'Kühlschränke',
            'Waschmaschinen usw.',
            'Radios',
            'Alles mit Stecker oder elektrischem Betrieb'
        ]
    },
    'sperrmuell': {
        title: 'SPERRMÜLL',
        icon: SPERRMUELL,
        slug: 'sperrmuell',
        shortDescription: 'Alte Möbel und sperrige Haushaltsgegenstände',
        description: 'Sperrmüll umfasst alte Möbel, Matratzen, Teppiche und andere sperrige Haushaltsgegenstände, die nicht in die normale Mülltonne passen.',
        allowed: [
            'Alte Möbel',
            'Matratzen',
            'Teppiche',
            'Sperrige Haushaltsgegenstände'
        ],
        notAllowed: [],
        status: 'incomplete'
    },
    'papier-pappe': {
        title: 'PAPIER & PAPPE',
        icon: PAPIERUNDPAPPE,
        detailImage: PAPIER_PAPPE_IMAGE,
        slug: 'papier-pappe',
        shortDescription: 'Kartonagen und Papiererzeugnisse',
        description: 'Kartonagen, Papier, Zeitungen und andere Papiererzeugnisse sind wichtig für das Recycling und die Umwelt.',
        allowed: [
            'Kartonagen',
            'Papier',
            'Zeitungen',
            'Papiererzeugnisse'
        ],
        notAllowed: [],
        status: 'incomplete'
    },
    'boden-steine': {
        title: 'BODEN & STEINE',
        icon: BODENUNDSTEINE,
        detailImage: BODEN_STEINE_IMAGE,
        slug: 'boden-steine',
        shortDescription: 'Erdaushub, Steine, Sand und Kies',
        description: 'Unbelasteter Erdaushub, Steine, Sand und Kies sind ideal für Garten- und Landschaftsbauarbeiten.',
        allowed: [
            'Unbelasteter Erdaushub',
            'Steine',
            'Sand',
            'Kies'
        ],
        notAllowed: [],
        status: 'incomplete'
    },
    'gemischte-abfaelle': {
        title: 'GEMISCHTE ABFÄLLE',
        icon: GEMISCHTEABFAELLE,
        slug: 'gemischte-abfaelle',
        shortDescription: 'Verschiedene nicht sortierte Abfälle',
        description: 'Verschiedene nicht sortierte Abfälle aus Haushalt und Gewerbe, die keiner speziellen Kategorie zugeordnet werden können.',
        allowed: [
            'Verschiedene Abfallarten'
        ],
        notAllowed: [],
        status: 'incomplete'
    }
};

// Content Section Component
function ContentSection({ title, items, icon, iconColor }) {
    if (!items || items.length === 0) return null;

    return (
        <div className="mb-8">
            <div className="flex items-center gap-3 mb-4">
                {iconColor === 'green' ? (
                    <FontAwesomeIcon icon={icon} className={`text-green-500 text-2xl`} />
                ) : iconColor === 'red' ? (
                    <FontAwesomeIcon icon={icon} className={`text-red-500 text-2xl`} />
                ) : iconColor === 'yellow' ? (
                    <FontAwesomeIcon icon={icon} className={`text-yellow-500 text-2xl`} />
                ) : null}
                <h3 className="text-xl lg:text-2xl font-bold text-gray-900">
                    {title}
                </h3>
            </div>
            <ul className="space-y-2 ml-8">
                {items.map((item, index) => (
                    <li key={index} className="flex items-start gap-3">
                        <span className="text-pink-600 font-bold mt-1">•</span>
                        <span className="text-gray-700">{item}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default function WasteTypeDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const wasteType = wasteTypeData[id];

    // Scroll to top on component mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [id]);

    // Handle back button - navigate to home and scroll to wastetype section
    const handleBack = () => {
        navigate('/');
        // Use setTimeout to ensure navigation completes before scrolling
        setTimeout(() => {
            const element = document.getElementById('abfallarten');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }, 100);
    };

    if (!wasteType) {
        return (
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                <div className="text-center px-4">
                    <h1 className="text-3xl font-bold text-gray-900 mb-4">Abfallart nicht gefunden</h1>
                    <button
                        onClick={() => navigate('/')}
                        className="bg-pink-600 text-white px-8 py-3 rounded-lg hover:bg-pink-700 transition font-bold"
                    >
                        Zurück zur Startseite
                    </button>
                </div>
            </div>
        );
    }

    const isIncomplete = wasteType.status === 'incomplete';

    return (
        <div className="min-h-screen flex flex-col bg-white">
            {/* Header Navigation */}
            <header className="bg-white shadow-sm sticky top-0 z-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-32">
                        <div className="flex items-center">
                            <Link to="/" className="flex items-center">
                                <img src={Logo} alt="Hirsch Logo" className="h-12 lg:h-24" />
                            </Link>
                        </div>
                        <nav className="hidden lg:flex items-center space-x-8">
                            <button className="text-gray-600 hover:text-gray-900 font-medium text-xl flex items-center gap-1">
                                <a href='/#hero'>Jetzt buchen!</a>
                            </button>
                            <button className="text-gray-600 hover:text-gray-900 font-medium text-xl flex items-center gap-1">
                                <a href='/#abfallarten'>Abfallarten</a>
                            </button>
                            <Link
                                to="/cart"
                                className="bg-pink-600 text-white px-6 py-2.5 rounded-md hover:bg-pink-700 transition-colors font-bold text-sm uppercase"
                            >
                                Warenkorb
                            </Link>
                        </nav>
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <div className="flex-1 min-h-screen bg-gradient-to-b from-pink-50 to-white py-12 sm:py-16 lg:py-24">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="mb-8 flex flex-wrap items-center gap-3 sm:gap-4 justify-between">
                        <button
                            onClick={handleBack}
                            className="inline-flex items-center text-pink-600 hover:text-pink-700 transition font-medium"
                        >
                            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                            </svg>
                            Zurück zu den Abfallarten
                        </button>
                    </div>

                    <div className="max-w-5xl mx-auto">
                        {/* Header Section */}
                        <div className="bg-gradient-to-r from-pink-600 to-pink-700 rounded-2xl shadow-xl p-8 sm:p-12 mb-12 text-white">
                            <div className="flex items-start gap-6 sm:gap-8">
                                <div className="w-24 h-24 sm:w-32 sm:h-32 flex-shrink-0 flex items-center justify-center bg-white rounded-lg">
                                    <img
                                        src={wasteType.icon}
                                        alt={wasteType.title}
                                        className="w-20 h-20 sm:w-28 sm:h-28 object-contain"
                                    />
                                </div>
                                <div>
                                    <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4">
                                        {wasteType.title}
                                    </h1>
                                    {/* <p className="text-pink-100 text-lg sm:text-xl leading-relaxed">
                                        {wasteType.shortDescription}
                                    </p> */}
                                    {isIncomplete && (
                                        <div className="mt-4 bg-yellow-100 text-yellow-800 px-4 py-2 rounded-lg inline-block">
                                            ⚠️ Informationen werden noch ergänzt
                                        </div>
                                    )}
                                    {id !== 'sonstige-abfaelle' && (
                                        <button
                                            onClick={() => navigate('/', {
                                                state: {
                                                    preservedPlz: sessionStorage.getItem('booking_plz') || '',
                                                    preservedPlacementType: sessionStorage.getItem('booking_placement_type') || '',
                                                    prefilledWasteTypeSlug: id
                                                }
                                            })}
                                            className="mt-6 bg-white text-pink-700 px-5 py-2.5 rounded-lg hover:bg-pink-50 transition font-bold shadow-md hover:shadow-lg"
                                        >
                                            Abfallart wählen
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Introduction */}
                        <div className="bg-white rounded-xl shadow-md p-8 sm:p-10 mb-8">
                            <p className="text-lg text-gray-700 leading-relaxed">
                                {wasteType.description}
                            </p>
                        </div>

                        {wasteType.detailImage && (
                            <div className="bg-white rounded-xl shadow-md p-4 sm:p-6 mb-8">
                                <img
                                    src={wasteType.detailImage}
                                    alt={`${wasteType.title} Beispielbild`}
                                    className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg"
                                />
                            </div>
                        )}

                        {/* Content Grid */}
                        {id !== 'sonstige-abfaelle' && (
                            <div className="bg-white rounded-xl shadow-md p-8 sm:p-10 mb-8">
                                <div className="space-y-10">
                                    {/* Was darf rein */}
                                    <div>
                                        <ContentSection
                                            title="Was darf rein"
                                            items={wasteType.allowed}
                                            icon={faCheck}
                                            iconColor="green"
                                        />
                                    </div>

                                    {/* Was darf nicht rein */}
                                    {wasteType.notAllowed && wasteType.notAllowed.length > 0 && (
                                        <div className="pt-8 border-t border-gray-200">
                                            <ContentSection
                                                title="Was darf nicht rein"
                                                items={wasteType.notAllowed}
                                                icon={faX}
                                                iconColor="red"
                                            />
                                        </div>
                                    )}

                                    {/* Gefährliche Abfälle */}
                                    {wasteType.dangerous && wasteType.dangerous.length > 0 && (
                                        <div className="pt-8 border-t border-gray-200">
                                            <div className="bg-red-50 rounded-lg p-6 border-2 border-red-200">
                                                <ContentSection
                                                    title="Gefährliche Abfälle"
                                                    items={wasteType.dangerous}
                                                    icon={faWarning}
                                                    iconColor="yellow"
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Contact & CTA */}
                        <div className="bg-white rounded-xl shadow-md p-8 sm:p-10 mb-8">
                            <div className="grid sm:grid-cols-2 gap-8">
                                <div className="bg-pink-50 rounded-lg p-6">
                                    <h3 className="text-xl font-bold text-pink-600 mb-4">Haben Sie Fragen?</h3>
                                    <div className="space-y-3 text-gray-700">
                                        <p className="flex items-center gap-2">
                                            <span className="font-bold"><FontAwesomeIcon icon={faEnvelope} /></span>
                                            <a href="mailto:big-bag@hirsch-gmbh.com" className="hover:text-pink-600 transition">
                                                container@hirsch-gmbh.com
                                            </a>
                                        </p>
                                    </div>
                                </div>

                                <div className="bg-gradient-to-br from-pink-100 to-pink-50 rounded-lg p-6 flex flex-col justify-center">
                                    <p className="text-gray-700 font-medium">
                                        Wählen Sie oben Abfallart wählen, um direkt mit dieser Abfallart ins Booking zu springen.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <footer id="footer" className="bg-gray-100 text-gray-700 relative" >
                <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12 max-w-6xl mx-auto">
                        {/* UNTERNEHMEN */}
                        <div>
                            <h3 className="text-sm font-bold mb-4 text-gray-500 uppercase tracking-wider">UNTERNEHMEN</h3>
                            <ul className="space-y-2 text-sm text-gray-600">
                                <a href="https://hirsch-group.de/barrierefreiheitserklaerung"><li><span className="hover:text-pink-600 transition-colors cursor-pointer">Barrierefreiheitserklärung</span></li></a>
                                <a href="https://hirsch-group.de/widerrufsbelehrung"><li><span className="hover:text-pink-600 transition-colors cursor-pointer">Widerrufsbelehrung</span></li></a>
                                <a href="https://hirsch-group.de/datenschutz"><li><span className="hover:text-pink-600 transition-colors cursor-pointer">Datenschutz</span></li></a>
                                <a href="https://hirsch-group.de/kontakt"><li><span className="hover:text-pink-600 transition-colors cursor-pointer">Kontakt</span></li></a>
                                <a href="https://hirsch-group.de/impressum"><li><span className="hover:text-pink-600 transition-colors cursor-pointer">Impressum</span></li></a>
                                <a href="https://hirsch-group.de/agb"><li><span className="hover:text-pink-600 transition-colors cursor-pointer">AGB</span></li></a>
                            </ul>
                        </div>

                        {/* ÖFFNUNGSZEITEN */}
                        <div>
                            <h3 className="text-sm font-bold mb-4 text-gray-500 uppercase tracking-wider">ÖFFNUNGSZEITEN</h3>
                            <ul className="space-y-2 text-sm text-gray-600">
                                <li className="flex justify-between">
                                    <span>Montag</span>
                                    <span>07:00 - 15:30 Uhr</span>
                                </li>
                                <li className="flex justify-between">
                                    <span>Dienstag</span>
                                    <span>07:00 - 15:30 Uhr</span>
                                </li>
                                <li className="flex justify-between">
                                    <span>Mittwoch</span>
                                    <span>07:00 - 15:30 Uhr</span>
                                </li>
                                <li className="flex justify-between">
                                    <span>Donnerstag</span>
                                    <span>07:00 - 15:30 Uhr</span>
                                </li>
                                <li className="flex justify-between">
                                    <span>Freitag</span>
                                    <span>07:00 - 15:30 Uhr</span>
                                </li>
                                <li className="flex justify-between font-semibold">
                                    <span>Samstag</span>
                                    <span>GESCHLOSSEN</span>
                                </li>
                                <li className="flex justify-between font-semibold">
                                    <span>Sonntag</span>
                                    <span>GESCHLOSSEN</span>
                                </li>
                            </ul>
                        </div>

                        {/* KONTAKT */}
                        <div>
                            <div className="mb-6">
                                <img src={Logo} alt="Hirsch Logo" className="h-12 mb-6" />
                            </div>
                            <div className="space-y-3 text-sm text-gray-600">
                                <div className="flex items-start gap-2">
                                    <svg className="w-5 h-5 text-pink-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                                    </svg>
                                    <span>+49 (0) 421 - 25802 - 580</span>
                                </div>
                                <div className="flex items-start gap-2">
                                    <svg className="w-5 h-5 text-pink-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                    </svg>
                                    <span>container@hirsch-gmbh.com</span>
                                </div>
                                <div className="flex items-start gap-2">
                                    <svg className="w-5 h-5 text-pink-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                                    </svg>
                                    <span>Hermann-Funk-Straße 6-9, 28309 Bremen</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bremen Skyline Section */}
                <div className="relative" >


                    {/* Pink Background Section with Copyright */}
                    <div className="bg-pink-600 text-white py-4">
                        <div className="container mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center">
                            <p className="text-sm">© All rights reserved</p>

                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}
